import SvgIcon from '@home/components/SvgIcon'; 
import React, { useMemo } from 'react';
import { Form, Input } from 'tea-component';
import { useIntl } from 'umi';

type GPTSummaryNameFormType = {
  name: string;
  setName: (value: string) => void;
  // emailList: Array<string>;
  // setEmailList: (value: Array<string>) => void;
  // showEmailMessage: boolean;
  // setShowEmailMessage: (value: boolean) => void;
  placeholder?: string;
  isFirst?: boolean;
};

export function GPTSummaryNameForm({
  needSummaryName,
  name,
  setName,
  // emailList,
  // setEmailList,
  // setShowEmailMessage,
  // showEmailMessage,
  placeholder,
  isFirst = false
}: GPTSummaryNameFormType & {
  needSummaryName?: boolean;
}) {
  const { formatMessage } = useIntl();
  const error = useMemo(() => {
    if (isFirst) {
      return null;
    }
    if (!name.trim()) {
      return formatMessage({ id: "Can't be null" });
    }

    return null;
  }, [name, isFirst, formatMessage]);

  if (!needSummaryName) return null;

  return (
    <>
      <Form.Item
        required
        showStatusIcon={false}
        label={formatMessage({ id: 'Summary Name' })}
        className="dbo-aigc-radio-wrapper"
        status={error ? 'error' : undefined}
        message={error}
      >
        <Input
          size="full"
          value={name}
          onChange={(value) => setName(value)}
          placeholder={placeholder || formatMessage({ id: 'Please enter a name for report' })}
        />
        {
          name !== '' && (
            <SvgIcon type={'clear-icon'} className='dbo-aigc-radio-wrapper-clear-icon' onClick={() => setName('')} />
          )
        }
      </Form.Item>
      {/* // TODO: 屏蔽Email */}
      {/* <Form.Item
        showStatusIcon={false}
        label={formatMessage({ id: 'Receiver Email' })}
        className="dbo-aigc-radio-wrapper"
        message={
          showEmailMessage
            ? formatMessage({ id: 'Please enter the correct email address' })
            : ''
        }
        status={showEmailMessage ? 'error' : undefined}
      >
        <EmailInput
          value={emailList}
          placeholder={formatMessage({
            id: 'The report will be sent to this email automatically upon generation',
          })}
          onChange={(tags, isError) => {
            setEmailList(tags);
            setShowEmailMessage(isError);
          }}
        />
      </Form.Item> */}
    </>
  );
}
